import React from 'react'
import { motion } from 'framer-motion'
import { useRevealInView } from '../../lib/useRevealInView'
import { REVEAL_Y, REVEAL_VIEWPORT, revealTransition } from '../../lib/revealMotion'

/** Reveal ao scroll — mesma animação em telemóvel, tablet e PC (ignora prefers-reduced-motion do Windows). */
export default function Reveal({ children, delay = 0, className = '', as = 'div' }) {
  const { ref, revealed } = useRevealInView(REVEAL_VIEWPORT)
  const MotionTag = motion[as] || motion.div

  return (
    <MotionTag
      ref={ref}
      className={className}
      initial={false}
      animate={revealed ? { opacity: 1, y: 0 } : { opacity: 0, y: REVEAL_Y }}
      transition={revealTransition(delay, revealed)}
    >
      {children}
    </MotionTag>
  )
}
